import { gql } from "@apollo/client";

export const DELETE_CLIENT_INTEGRATION = gql`
  mutation DeleteClientIntegration($input: DeleteClientIntegrationInput!) {
    deleteClientIntegration(input: $input) {
      mrn
    }
  }
`;
